import { render, staticRenderFns } from "./AppList.vue?vue&type=template&id=360b3566&scoped=true&"
import script from "./AppList.vue?vue&type=script&lang=js&"
export * from "./AppList.vue?vue&type=script&lang=js&"
import style0 from "./AppList.vue?vue&type=style&index=0&id=360b3566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360b3566",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('360b3566')) {
      api.createRecord('360b3566', component.options)
    } else {
      api.reload('360b3566', component.options)
    }
    module.hot.accept("./AppList.vue?vue&type=template&id=360b3566&scoped=true&", function () {
      api.rerender('360b3566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/basic/event/AppList.vue"
export default component.exports